<template>
	<div>
		<span>Document verstuurd</span>
	</div>
</template>
